import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { FailedAttempts } from './components/FailedAttempts';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
import { initPixel, trackPageView } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#09090b] text-zinc-50 font-sans selection:bg-amber-500/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Problem data-id="element-3" />
        <FailedAttempts data-id="element-4" />
        <Mechanism data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <WhoIsFor data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Proof data-id="element-9" />
        <FAQ data-id="element-10" />
        <Bonuses data-id="element-11" />
        <Offer data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}